/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateOrganizationalUnitDto
 */
export interface CreateUpdateOrganizationalUnitDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateOrganizationalUnitDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateOrganizationalUnitDto
     */
    unit: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateOrganizationalUnitDto
     */
    shortname: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateOrganizationalUnitDto
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateOrganizationalUnitDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateOrganizationalUnitDto
     */
    parentId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateOrganizationalUnitDto
     */
    notified: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateOrganizationalUnitDto
     */
    nationalTechnicalAssessmentUnit: boolean;
}

export function CreateUpdateOrganizationalUnitDtoFromJSON(json: any): CreateUpdateOrganizationalUnitDto {
    return CreateUpdateOrganizationalUnitDtoFromJSONTyped(json, false);
}

export function CreateUpdateOrganizationalUnitDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateOrganizationalUnitDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'unit': json['unit'],
        'shortname': json['shortname'],
        'address': json['address'],
        'city': json['city'],
        'parentId': json['parentId'],
        'notified': json['notified'],
        'nationalTechnicalAssessmentUnit': json['nationalTechnicalAssessmentUnit'],
    };
}

export function CreateUpdateOrganizationalUnitDtoToJSON(value?: CreateUpdateOrganizationalUnitDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'unit': value.unit,
        'shortname': value.shortname,
        'address': value.address,
        'city': value.city,
        'parentId': value.parentId,
        'notified': value.notified,
        'nationalTechnicalAssessmentUnit': value.nationalTechnicalAssessmentUnit,
    };
}


